// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1284":"9e4c683f","9445":"9e4c683f","9491":"9e4c683f"}[chunkId] + ".chunk.css";
};